<template>
  <div>
    <!--<base-header></base-header>-->
    <div class="container">
      <form @submit.prevent="setPassword">
        <div class="form-header">Enter SIP credentials</div>
        <p>Consult your administrator</p>
        <div class="form-group">
          <input type="text" class="form-control text-center" v-model="username" placeholder="SIP username" :class="{'form-error': errorMessage['username']}" autocomplete="off" />
          <p v-for="msg in errorMessage['username']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="password" class="form-control text-center" v-model="password" placeholder="SIP password" :class="{'form-error': errorMessage['password']}" autocomplete="new-password" />
          <p v-for="msg in errorMessage['password']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group">
          <input type="text" class="form-control text-center" v-model="domain" placeholder="SIP domain" :class="{'form-error': errorMessage['domain']}" autocomplete="off" />
          <p v-for="msg in errorMessage['domain']" class="text-error">{{msg}}</p>
        </div>
        <div class="form-group text-center btn-submit">
          <base-button type="submit" class="btn-block" :disabled="username.length == 0 || password.length == 0 || domain.length == 0">Next</base-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import Slide from '../components/Slide';
  import BaseButton from "../components/Button.vue";
  import BaseHeader from "../components/Header.vue";

  export default {
    components: {
      BaseHeader,
      BaseButton,
      Slide,
    },
    name: 'SIPCredentialsPage',
    props: {
      phone: String,
      token: String,
    },
    data() {
      return {
        username: '',
        password: '',
        domain: '',
        errorMessage: []
      };
    },
    methods: {
      setPassword() {
        this.errorMessage = [];
        const formData = new FormData();
        formData.append('phone', this.phone);
        formData.append('token', this.token);
        formData.append('username', this.username);
        formData.append('password', this.password);
        formData.append('domain', this.domain);
        this.axios.post('/sip', formData).then((response) => {
          if ((response.data.status)) {
            window.localStorage.setItem('url', response.data.data.url);
            this.$router.push({name: 'RegisterPage', params: {token: response.data.data.token}});
          } else {
            this.errorMessage = response.data.data;
          }
        })
      }
    }
  };
</script>
<style scoped="">
</style>



// WEBPACK FOOTER //
// src/pages/SIPCredentialsPage.vue